module.exports = "<div class=\"container\">\r\n  <br>\r\n  <p-growl [(value)]=\"msgs\"></p-growl>\r\n  <div class=\"form-row\">\r\n    <div class=\"form-group\"\r\n      *ngIf=\"(userDetails)\">\r\n      <div class=\"card-title\">\r\n        <h3>שלום {{userDetails.FirstName}} {{userDetails.LastName}}</h3>\r\n        \r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n\r\n<div class=\"container\" *ngIf=\"(dataResults) && (userDetails) \">\r\n\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/main-page/main-page.component.html
// module id = ../../../../../src/app/main-page/main-page.component.html
// module chunks = main